import { useState } from 'react';
import styled from 'styled-components';

import { Arrow } from '@assets/icons';
import { UnstyledButton } from '@components/UnstyledButton/UnstyledButton';

type FilterCollapseProps = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  content: React.ReactNode;
};

export const FilterCollapse = ({
  title,
  subtitle,
  content,
}: FilterCollapseProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <StyledContainer>
      <StyledFilterButton onClick={() => setIsOpen((prev) => !prev)}>
        <div className='header'>
          <div className='title'>{title}</div>
          <div className='collapse-icon-container'>
            <Arrow direction={isOpen ? 'up' : 'down'} />
          </div>
        </div>
        {!isOpen && <div className='subtitle'>{subtitle}</div>}
      </StyledFilterButton>
      {isOpen && content}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  text-align: left;
`;

const StyledFilterButton = styled(UnstyledButton)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  text-align: left;

  .header {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
      padding: 4px 0;
    }

    .title {
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      width: calc(100% - 28px);

      @media (max-width: 768px) {
        font-size: 20px;
        line-height: 24px;
      }
    }

    .collapse-icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;

      svg {
        width: 9.6px;
        height: auto;
      }
    }
  }

  .subtitle {
    color: ${({ theme }) => theme.palette.text[9]};

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
      color: ${({ theme }) => theme.palette.text[0]};
    }
  }
`;
